import React, { useContext } from "react";

import "./styles.scss";
import { useMutation } from "@apollo/client";
import { Row } from "antd";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Button from "shared/components/Button";
import CheckBox from "shared/components/CheckBox";
import Input from "shared/components/Input";
import Logo from "shared/components/Logo";
import Notification from "shared/components/Notification";
import Space from "shared/components/Space";
import { SIGN_IN_WITH_EMAIL } from "shared/graphql/mutations";
import { DEFAULT_VALUES, NAME_SPACES } from "shared/locals/constants";
import { StoreContext } from "shared/store";
import { PATHS } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";

import External from "./External";
import validation from "./validation";
import {PrivacyPolicyLink} from "../../../shared/components/PrivacyPolicyLink";

const SignIn = () => {
  const history = useHistory();
  const { t } = useTranslation(NAME_SPACES.AUTH);
  const { t: tError } = useTranslation(NAME_SPACES.ERRORS);
  const { setLoggedIn, setEmail } = useContext(StoreContext);

  const [login] = useMutation(SIGN_IN_WITH_EMAIL, {
    onCompleted: () => {
      setLoggedIn(true);
      history.push(PATHS.FILE.HOME);
    },
    onError: (error) => {
      // look for the error-code with prefix `AUTH`: try find error-code in message's extensions, otherwise take `GENERIC`.
      // If no message with prefixed error-code found, try find error-message in message's extensions, otherwise take `GENERIC` error code as fallback code
      let _error = tError([
        "AUTH." + (error.graphQLErrors?.[0]?.extensions?.code || "GENERIC"),
        error.graphQLErrors?.[0]?.extensions?.messages || "GENERIC",
      ]);
      Notification.error({
        duration: DEFAULT_VALUES.NOTIFICATION_DURATION,
        message: _error,
      });
    },
  });

  return (
    <div className={"auth-page"}>
      <Logo width={128} withDesc={false} />
      <Space h={54} />
      <div className={"form"}>
        <p className={"title"}>{t("CONNEXION")}</p>
        <Space h={44} />
        <External />
        <Space h={44} />
        <div className={"spaced-row"}>
          <div className={"line"} />
          <p className={"or"}>{t("OR")}</p>
          <div className={"line"} />
        </div>
        <Space h={44} />
        <Formik
          initialValues={{ username: "", password: "" }}
          onSubmit={(data) => {
            setEmail(data.username);
            login({
              variables: {
                data: {
                  ...data,
                },
              },
            });
          }}
          validationSchema={validation(
            t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
          )}>
          {({ handleSubmit, ...formProps }) => [
            <Input
              key={"input:username"}
              placeholder={t("LOGIN")}
              {...bindInputProps({ name: "username", ...formProps })}
            />,
            <Space key={"space:1"} h={32} />,
            <Input
              key={"input:password"}
              placeholder={t("PASSWORD")}
              type={"password"}
              {...bindInputProps({ name: "password", ...formProps })}
            />,
            <p
              key={"forgot"}
              className={"forgot-password"}
              onClick={() => history.push(PATHS.AUTH.RESET_PASSWORD)}>
              {t("FORGOT")}
            </p>,
            <Space key={"space:2"} h={32} />,
            <div key={"input:keplogged"} className={"checkbox"}>
              <CheckBox label={t("KEEP_LOGGED")} />
            </div>,
            <Space key={"space:3"} h={32} />,
            <Button
              key={"submit:login"}
              text={t("CONNECT")}
              fillWidth
              onClick={handleSubmit}
            />,
          ]}
        </Formik>
        <Row>
          <p className={"no-account"}>{t("NO_ACCOUNT")}</p>
          <u>
            <p
              className={"no-account bold"}
              onClick={() => history.push(PATHS.AUTH.SIGN_UP)}>
              {t("REGISTER")}
            </p>
          </u>
        </Row>
      </div>
      <div><PrivacyPolicyLink/></div>
    </div>
  );
};

export default SignIn;
